export default __webpack_public_path__ + "assets/c050188c6232b525c19a10bfe27a8a98.png";